import * as yup from 'yup'

export const mfaCodeFormSchema = yup
  .object()
  .noUnknown(true)
  .shape({
    mfaCode: yup.string().required('mfaCodeVerify.missingProvidedCode'),
  })
